import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Send"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.7823 3.21747C20.5756 3.01178 20.2685 2.94451 19.9948 3.04497L3.49476 9.04497C3.20341 9.15548 3.01074 9.43462 3.01074 9.74622C3.01074 10.0578 3.20341 10.337 3.49476 10.4475L10.6948 13.3275L13.5748 20.5275C13.6853 20.8055 13.9506 20.9912 14.2498 21C14.56 20.9936 14.8343 20.7968 14.9398 20.505L20.9398 4.00497C21.0441 3.73411 20.9827 3.42738 20.7823 3.21747ZM14.2498 18.15L12.1573 12.9L15.7498 9.30747L14.6923 8.24997L11.0698 11.8725L5.84981 9.74997L18.9973 5.00247L14.2498 18.15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Send.vue"]]);
